import styled from 'styled-components'

export const Messages = styled.ol`
  max-height: 12rem;
  list-style: none;
`
